import React from "react";
import { Box } from "@caspeco/casper-ui-library.components.box";
import { Text } from "@caspeco/casper-ui-library.components.text";
import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { IAddonGroup } from "types/cartArticle";
import Price from "components/price/Price";

interface ICartRowAddons {
	extraGroups: IAddonGroup[];
	optionsGroups: IAddonGroup[];
}

function CartRowAddons({ extraGroups, optionsGroups }: ICartRowAddons) {
	const renderAddonGroups = (addonGroups: IAddonGroup[]) =>
		addonGroups.map((addonGroup, i) => (
			<React.Fragment key={i}>
				{addonGroup.addons.length > 0 &&
					addonGroup.addons.map((addon) => (
						<Flex key={addon.id} gap={ThemeSpaceVariable.XSmall}>
							<Text
								key={addon.id}
								fontSize={ThemeFontSizeVariable.Small}
								wordBreak="break-word"
								color={ThemeColorVariable.OnSurfaceSubdued}
							>
								{`${addon.name}`}{" "}
								<Price
									as="span"
									color={ThemeColorVariable.OnSurfaceSubdued}
									fontSize={ThemeFontSizeVariable.Small}
									inHousePrice={addon.amount}
									prepend="("
									append=")"
								/>
							</Text>
						</Flex>
					))}
			</React.Fragment>
		));

	return (
		<Box display="block" w="100%" mt={ThemeSpaceVariable.XSmall}>
			{renderAddonGroups(optionsGroups)}
			{renderAddonGroups(extraGroups)}
		</Box>
	);
}

export default CartRowAddons;
